export default {
    view: {
        success: {
            header: "Ankieta przesłana",
            message: "Dziękujemy za twoją opinię."
        },
        productChoice: {
            cta: "Ratować",
            processing: "Oszczędność"
        },
        addressForm: {
            cta: "Ratować",
            processing: "Oszczędność"
        }
    },
    delivery: {
        title: "Badanie dostawy",
        message: "Czy otrzymałeś wszystkie wymienione poniżej elementy?",
        cta: {
            yes: "Tak",
            no: "NIE",
            processing: "Oszczędność"
        }
    }
}